import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import { useUserPhoneSettings } from '../../../sic-lib/api/hooks/useUser';
import { editUserTwilioPhoneDefaults } from '../../../sic-lib/defaults';
import AxiosErrorAlert from '../../Shared/Alerts/AxiosErrorAlert';
import Loader from '../../Shared/Loader';
import { ChangeSicNumberForm } from './ChangeSicNumberForm';

export function ChangeSicNumber() {
    const { classes } = useStyles();

    const { data: phoneSettings, isLoading, isError, error } = useUserPhoneSettings();

    return (
        <Loader isLoading={isLoading}>
            <ChangeSicNumberForm phoneSettings={phoneSettings || editUserTwilioPhoneDefaults} />
            {isError && <AxiosErrorAlert error={error} />}
        </Loader>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({}));
